/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import useDashboardContext from "routes/utils/context/useDashboardContext";

const useLibrarianCampus = ({
    changeFilter, isLibrarian
}) => {
    const { userCampusId } = useDashboardContext();
    useEffect(() => {
        if (isLibrarian && userCampusId)
            changeFilter("campusId", userCampusId);
    }, [userCampusId]);
}

export default useLibrarianCampus;